import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconRowing = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconRowing",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m692-28-80-80q-6-6-9-13t-3-16v-43L316-464l-18 3-18 1v-88q50 2 102-21t84-59l56-62q13-15 31-22t37-8q38 0 64 26t26 64v230q0 26-9 48t-27 38L500-456v-92q-20 17-43 31t-49 25l252 252h43q8 0 16 3t13 9l80 80q12 12 12 28t-12 28l-64 64q-12 12-28 12t-28-12M360-280 250-170q-13 13-30 13t-30-13-13-30 13-30l150-150 100 100zm240-480q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23M280-460q-18 0-31-13t-13-31 13-31 31-13 31 13 13 31-13 31-31 13"
  })
}));